import React from "react";
import AppHeader from "components/AppHeader/AppHeader";
import { Main, Container, Shadow } from "theme/GlobalElements";
import TopLevelRouter from "routers/TopLevelRouter";
import AppBackdrop from "features/appBackdrop/AppBackdrop";
import RootModal from "features/rootModal/RootModal";
import Footer from "components/Footer";
import ScrollToTop from "components/ScrollToTop/ScrollToTop";
import CompareMessage from "features/message/Message";
import GlobalStyle from "theme/globalStyled";
import MobileBottomTabBar from "components/MobileBottomBar/MobileBottomTabBar";
import Banner from "components/Banner/Banner";
import MetaData from "components/MetaData/MetaData";
import TagManager from "react-gtm-module";

const tagManagerArgs = {
  gtmId: "GTM-T5J2KXB",
};

TagManager.initialize(tagManagerArgs);
const ShopLayout = () => {
  return (
    <>
      <MetaData />
      <div style={{ position: "relative" }}>
        <ScrollToTop />
        <GlobalStyle />
        <AppHeader />
        <Banner />
        <Main>
          <Container>
            <TopLevelRouter />
          </Container>
          <Shadow />
        </Main>
        <Footer />
        <AppBackdrop />
        <RootModal />
        <CompareMessage />
        <MobileBottomTabBar />
      </div>
    </>
  );
};

export default ShopLayout;
